import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, trackFeature } from '@/utils/analytics';
import { trackSessionPageView, trackFeatureUsage } from '@/utils/sessionTracker';

/**
 * Map of route paths to feature names for feature adoption tracking
 */
const ROUTE_TO_FEATURE_MAP: Record<string, string> = {
  '/tasks': 'tasks',
  '/checklists': 'checklists',
  '/forms': 'forms',
  '/assets': 'assets',
  '/evidence-vault': 'evidence_vault',
  '/compliance-management': 'compliance_management',
  '/locations': 'locations',
  '/user-management': 'user_management',
  '/messages': 'messaging',
  '/help': 'help_center',
  '/settings': 'settings',
};

/**
 * Component to track page views for analytics
 * Should be placed inside Router but outside Routes
 */
const PageViewTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const fullPath = pathname + location.search;

    // Track page view on route change
    trackPageView(fullPath);
    
    // Track session page view
    trackSessionPageView();

    // Track feature access for feature adoption
    const featureName = ROUTE_TO_FEATURE_MAP[pathname];
    if (featureName) {
      trackFeature.accessed(featureName);
      trackFeatureUsage(featureName);
    }
  }, [location]);

  return null;
};

export default PageViewTracker;

